import React, { useEffect } from "react";
import CategoryService from "../../api/services/categoryService";

const CategoryList = ({ categories, onEdit, onDelete }) => {

  return (
    <div className="grid gap-2">
      {categories.length === 0 ? (
        <div className="p-3 text-gray-500">No categories yet</div>
      ) : (
        categories.map((c) => (
          <div
            key={c.id}
            className="flex items-center justify-between rounded-lg border border-gray-200 p-3"
          >
            <div className="font-medium text-gray-900">{c.title}</div>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => onEdit(c.title, c.id)}
                className="cursor-pointer rounded-md border border-gray-300 bg-white px-3 py-1"
              >
                Edit
              </button>
              <button
                type="button"
                onClick={() => onDelete(c.id)}
                className="cursor-pointer rounded-md border border-red-500 bg-red-50 px-3 py-1 text-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default CategoryList;


